__turbopack_context__.v({
  "ringAccessory": "AvatarOnRubberRing-module__deLNIW__ringAccessory",
});
